if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        // Koalla: Express-Buttons (PayPal & Co.) kaufen nur das Hauptprodukt,
        // deshalb verschwinden sie, solange ein Zusatzprodukt angehakt ist.
        this.addonInputs = Array.from(this.form.querySelectorAll('[data-koalla-addon]'));
        this.addonInputs.forEach((cb) => cb.addEventListener('change', this.toggleExpressButtons.bind(this)));
        this.toggleExpressButtons();
      }

      toggleExpressButtons() {
        const express = this.form.querySelector('.shopify-payment-button');
        if (!express || !this.addonInputs || !this.addonInputs.length) return;
        express.hidden = this.addonInputs.some((cb) => cb.checked);
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        let formData = new FormData(this.form);
        const mainVariantId = formData.get('id');
        // Koalla: angehakte Zusatzprodukte („Dazu passt“) im selben Aufruf mitnehmen.
        // /cart/add nimmt entweder id/quantity/properties oder items[] — nicht beides,
        // deshalb wandern die Hauptfelder bei Bedarf nach items[0].
        const addons = Array.from(this.form.querySelectorAll('[data-koalla-addon]:checked'));
        if (addons.length) {
          const packed = new FormData();
          for (const [key, value] of formData.entries()) {
            if (key === 'id') packed.append('items[0][id]', value);
            else if (key === 'quantity') packed.append('items[0][quantity]', value);
            else if (key.startsWith('properties[')) packed.append('items[0]' + key, value);
            else packed.append(key, value);
          }
          addons.forEach((addon, i) => {
            const n = i + 1;
            packed.append(`items[${n}][id]`, addon.dataset.addonId);
            packed.append(`items[${n}][quantity]`, '1');
            if (addon.dataset.addonVersand) packed.append(`items[${n}][properties][Versand]`, addon.dataset.addonVersand);
            if (addon.dataset.addonWelle) packed.append(`items[${n}][properties][_versandwelle]`, addon.dataset.addonWelle);
          });
          formData = packed;
        }
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: mainVariantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            // Antwort auf ein items[]-Paket ist { items: [...] }; der Drawer erwartet die Form eines Artikels.
            if (response.items && response.items.length && !response.id) response.id = response.items[0].id;
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: mainVariantId,
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
